import { Chip, withStyles } from "@material-ui/core";

const styles = (theme) => ({
  root: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary2.main,
  },
  icon: {
    color: theme.palette.common.white,
  },
});

export default withStyles(styles)(Chip);
